/* Lourun ostosavustaja – prototyyppi 10/2026
 * Pikavalinnat -> 0–2 kysymystä -> 2–3 varastossa olevaa suositusta tai valmis paketti -> koriin.
 * Data: /collections/ostosavustaja-data?view=avustaja (hinta ja saldo aina ajantasaiset).
 * Koriin lisätyt rivit saavat piilotetut ominaisuudet _lahde = ostosavustaja ja _avustaja = valinnan tunnus.
 */
(function () {
  'use strict';
  var root = document.getElementById('louru-avustaja');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var ALV = 1.255;
  var SS = window.sessionStorage;
  var store = {
    get: function (k) { try { return SS.getItem('la_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { SS.setItem('la_' + k, v); } catch (e) {} }
  };

  /* ---------- Paketit: oheislaitteet kahvalla, varalla saman roolin tuote ---------- */
  var H = {
    v15: 'lenovo-v15-g4-r5-5625u-15-6-8gb-512gb-kannettava-tietokone',
    e16: 'lenovo-e16-g3',
    telakka: 'lenovo-thinkpad-universal-usb-c-telakka',
    n24: 'dell-pro-24-plus-p2425hhf-monitori',
    n27: 'dell-pro-27-e2726ds-qhd-100hz-ips',
    combo: 'lenovo-essential-langaton-nappaimisto-ja-hiiri-g2-ai-nordic',
    kb216: 'dell-multimedia-usb-keyboard-kb216-fi-se',
    ms300: 'dell-ms300-wireless-mouse',
    usbhiiri: 'lenovo-essential-langallinen-usb-hiiri',
    voip: 'lenovo-langattomat-voip-toimistokuulokkeet',
    topload: 'thinkpad-essential-16-inch-topload-eco',
    sagano: 'targus-sagano-ecosmart-16-tietokonereppu',
    geolite: 'targus-geolite-ecosmart-13-14-tietokonelaukku'
  };

  /* ---------- Pikavalinnat ---------- */
  var PICKS = {
    yksityis: [
      { id: 'Y1', label: 'Netin selaukseen ja peruskäyttöön', tag: 'kaytto:perus',
        q: ['budjetti400', 'koko'] },
      { id: 'Y2', label: 'Kannettava opiskeluun', tag: 'kaytto:opiskelu',
        q: ['budjetti500', 'kanto'], pkg: 'opiskelija' },
      { id: 'Y3', label: 'Kevyt kone mukana kannettavaksi', tag: 'kaytto:liikkuva', q: ['budjetti500b'] },
      { id: 'Y8', label: 'En tiedä mitä tarvitsen, auta valitsemaan', route: 'Y8' },
      { id: 'Y5', label: 'Edullisin toimiva kone', tag: 'kaytto:*', sort: 'price' },
      { id: 'Y7', label: 'Lisävarusteita nykyiseen koneeseeni', acc: true },
      { id: 'Y4', label: 'Iso näyttö ja helppo käyttää', tag: 'kaytto:helppo' },
      { id: 'Y6', label: 'Kosketusnäyttö ja kynä', tag: 'kaytto:kosketus' }
    ],
    yritys: [
      { id: 'B1', label: 'Konepaketti uudelle työntekijälle', pkg: 'uusi', q: ['maara', 'taso'] },
      { id: 'B2', label: 'Toimistokäyttöön tasapainoinen valikoima', pkg: 'toimisto', q: ['naytot', 'kuulokkeet'] },
      { id: 'B3', label: 'Etätyöpiste kotiin', pkg: 'eta', q: ['omakone', 'nayttokoko'] },
      { id: 'B4', label: 'Useampi samanlainen kone', tag: 'kaytto:toimisto', q: ['maara4'] },
      { id: 'B5', label: 'Kevyt kone liikkuvaan työhön', tag: 'kaytto:liikkuva', q: ['budjettiB'] },
      { id: 'B7', label: 'Auta valitsemaan', route: 'B7' },
      { id: 'B6', label: 'Lisävarusteita nykyisiin koneisiin', acc: true }
    ]
  };

  var Q = {
    budjetti400: { t: 'Mikä on budjettisi?', o: [['alle 400 €', { max: 400 }], ['400–600 €', { min: 400, max: 600 }], ['Ei väliä', {}]] },
    budjetti500: { t: 'Mikä on budjettisi?', o: [['alle 500 €', { max: 500 }], ['500–800 €', { min: 500, max: 800 }], ['Ei väliä', {}]] },
    budjetti500b: { t: 'Mikä on budjettisi?', o: [['alle 500 €', { max: 500 }], ['Ei väliä', {}]] },
    budjettiB: { t: 'Budjetti per kone?', o: [['alle 500 €', { max: 500 }], ['Ei väliä', {}]] },
    koko: { t: 'Minkä kokoinen näyttö?', o: [['14″ – kevyempi kantaa', { size: 'pieni' }], ['15–16″ – isompi ruutu', { size: 'iso' }], ['Ei väliä', {}]] },
    kanto: { t: 'Kannatko konetta mukana päivittäin?', o: [['Kyllä', { carry: true }], ['En juurikaan', {}]] },
    maara: { t: 'Monelleko työntekijälle?', o: [['1', { n: 1 }], ['2–4', { n: 2 }], ['5 tai enemmän', { n: 5 }]] },
    maara4: { t: 'Montako konetta tarvitset?', o: [['2–4', { n: 2 }], ['5–20', { n: 5 }], ['Yli 20', { n: 20 }]] },
    taso: { t: 'Minkä tasoinen kone?', o: [['Perus – toimisto-ohjelmat ja palaverit', { taso: 'perus' }], ['Tehokas – paljon ohjelmia yhtä aikaa', { taso: 'tehokas' }]] },
    naytot: { t: 'Montako näyttöä pöydälle?', o: [['Ei erillistä näyttöä', { naytot: 0 }], ['1', { naytot: 1 }], ['2', { naytot: 2 }]] },
    kuulokkeet: { t: 'Tarvitaanko kuulokkeet palavereihin?', o: [['Kyllä', { kuulokkeet: true }], ['Ei', { kuulokkeet: false }]] },
    omakone: { t: 'Onko työntekijällä jo kone?', o: [['On, tarvitaan vain työpiste', { omakone: true }], ['Ei, kone mukaan', { omakone: false }]] },
    nayttokoko: { t: 'Minkä kokoinen näyttö?', o: [['24″ Full HD', { naytto: 24 }], ['27″ QHD – tarkempi kuva', { naytto: 27 }]] }
  };

  var ACC = [
    ['Laturi', 'laturi'], ['Telakka', 'telakka'], ['Näyttö', 'naytto'], ['Laukku tai reppu', 'laukku'],
    ['Näppäimistö ja hiiri', 'nappis-hiiri'], ['Kuulokkeet', 'kuulokkeet']
  ];

  var FAQ = {
    takuu: function () {
      return '<p><strong>Kunnostetuilla koneilla on 1 vuoden Louru-takuu.</strong> Uusilla koneilla on valmistajan takuu, jonka pituus näkyy tuotesivulla.</p><p><a href="' + root.dataset.takuu + '">Lue takuuehdot</a></p>';
    },
    kunnostettu: function () {
      return '<p>Kunnostettu kone on yrityskäytöstä palautunut laatukone, jonka Louru tarkastaa, huoltaa ja testaa itse ennen myyntiä. Myymme vain hyväkuntoisia yksilöitä, ja kunto näkyy jokaisen koneen kortissa.</p><p>Laturi tulee aina mukana, ja koneella on 1 vuoden Louru-takuu.</p>';
    },
    toimitus: function () {
      return '<p>Toimitus on ilmainen yli 200 €:n tilauksille. Tilauksen voi myös noutaa Kittilän myymälästä, yleensä 2 tunnin sisällä tilauksesta.</p><p>Kysyttävää? Soita 040 040 5878 tai kirjoita tuki@louru.fi.</p>';
    }
  };

  /* ---------- Tila ---------- */
  var S = { seg: null, pick: null, ans: {}, qi: 0, hist: [], shown: [] };
  var DATA = null, loading = null;
  var fab = root.querySelector('.la-fab');
  var panel = root.querySelector('.la-panel');
  var body = root.querySelector('.la-body');
  var backBtn = root.querySelector('.la-back');
  var teaser = root.querySelector('.la-teaser');

  /* ---------- Apuneuvot ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(cents) { return (cents / 100).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function alv0(cents) { return Math.round(cents / ALV); }
  function hasTag(p, t) {
    if (t === 'kaytto:*') return p.tags.some(function (x) { return x.indexOf('kaytto:') === 0; });
    return p.tags.indexOf(t) !== -1;
  }
  function isLaptop(p) { return p.tags.some(function (x) { return x.indexOf('kaytto:') === 0; }); }
  function inStock(p, n) { return p.a && (p.inv == null || p.inv >= (n || 1)); }
  function byHandle(h) { return DATA && DATA.filter(function (p) { return p.h === h; })[0]; }
  function track(name, data) {
    var d = Object.assign({ asiakastyyppi: S.seg, valinta: S.pick && S.pick.id }, data || {});
    (window.louruAvustajaLog = window.louruAvustajaLog || []).push([name, d, Date.now()]);
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('louru_avustaja_' + name, d); } catch (e) {}
  }

  function load() {
    if (DATA) return Promise.resolve(DATA);
    if (loading) return loading;
    var all = [];
    function page(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        all = all.concat(j.products || []);
        return j.next ? page(j.next + (j.next.indexOf('view=') === -1 ? '&view=avustaja' : '')) : all;
      });
    }
    loading = page(root.dataset.feed).then(function (list) { DATA = list; return list; });
    return loading;
  }

  /* ---------- Suosittelu ---------- */
  function candidates(pick, ans) {
    ans = ans || {};
    var list = DATA.filter(function (p) { return isLaptop(p) && hasTag(p, pick.tag) && inStock(p, ans.n || 1); });
    return list;
  }
  function score(p, ans) {
    var s = 0, price = p.p / 100;
    if ((ans.max == null || price <= ans.max) && (ans.min == null || price >= ans.min)) s += 3;
    var inch = parseFloat(p.m.in);
    if (ans.size === 'pieni' && inch && inch <= 14.5) s += 2;
    if (ans.size === 'iso' && inch && inch >= 15) s += 2;
    var kg = parseFloat(p.m.kg);
    if (ans.carry && kg && kg <= 1.6) s += 2;
    if (p.m.kunto === 'Kunnostettu') s += 1;
    if (p.inv === 1) s += 1;
    return s;
  }
  function fits(p, ans, relax) {
    var price = p.p / 100, inch = parseFloat(p.m.in);
    if (!relax.size) {
      if (ans.size === 'pieni' && !(inch && inch <= 14.5)) return false;
      if (ans.size === 'iso' && !(inch && inch >= 15)) return false;
    }
    if (!relax.price) {
      if (ans.max != null && price > ans.max) return false;
      if (ans.min != null && price < ans.min) return false;
    }
    return true;
  }
  function recommend(pick, ans) {
    var base = candidates(pick, ans);
    if (pick.sort === 'price') return { list: base.sort(function (a, b) { return a.p - b.p; }).slice(0, 3), note: '' };
    var relax = {}, note = '';
    var list = base.filter(function (p) { return fits(p, ans, relax); });
    if (!list.length && ans.size) { relax.size = true; list = base.filter(function (p) { return fits(p, ans, relax); }); if (list.length) note = 'Toivomasi kokoista konetta ei nyt ole tässä hintaluokassa, joten tässä lähimmät vaihtoehdot.'; }
    if (!list.length && (ans.max != null || ans.min != null)) { relax.price = true; list = base.slice(); if (list.length) note = 'Toivomaasi hintaluokkaan ei nyt ole sopivaa konetta, joten tässä lähimmät vaihtoehdot.'; }
    list.sort(function (a, b) { return score(b, ans) - score(a, ans) || a.p - b.p; });
    var top = list.slice(0, 3);
    var cheapest = list.slice().sort(function (a, b) { return a.p - b.p; })[0];
    if (cheapest && top.indexOf(cheapest) === -1) top[top.length - 1] = cheapest;
    return { list: top, note: note, cheapest: cheapest };
  }
  function whyText(p, ans) {
    var w = [];
    var kg = parseFloat(p.m.kg), inch = parseFloat(p.m.in);
    if (p.m.kunto === 'Kunnostettu') w.push('kunnostettu yrityskone selvästi uutta edullisemmin');
    if (ans.carry && kg && kg <= 1.6) w.push('kevyt kantaa (' + String(kg).replace('.', ',') + ' kg)');
    if (inch >= 17) w.push('iso ' + String(inch).replace('.', ',') + '″ näyttö ja numero-osa');
    if (hasTag(p, 'kaytto:kosketus')) w.push('kosketusnäyttö');
    if (p.m.ram >= 16) w.push(p.m.ram + ' Gt muistia riittää moneen ohjelmaan yhtä aikaa');
    if (p.m.takuu >= 24 && p.m.kunto !== 'Kunnostettu') w.push(p.m.takuu / 12 + ' vuoden valmistajan takuu');
    return w.slice(0, 2).join(', ');
  }

  /* ---------- Paketit ---------- */
  function pickRole(handle, role, n) {
    var p = byHandle(handle);
    if (p && inStock(p, n)) return p;
    return DATA.filter(function (x) { return hasTag(x, 'paketti:' + role) && inStock(x, n); }).sort(function (a, b) { return a.p - b.p; })[0] || null;
  }
  function bagFor(machine, prefer, n) {
    var inch = machine ? parseFloat(machine.m.in) : 15.6;
    if (prefer === 'reppu') return pickRole(H.sagano, 'laukku', n);
    return inch && inch <= 14.5 ? pickRole(H.geolite, 'laukku', n) : pickRole(H.topload, 'laukku', n);
  }
  function buildPackage(kind, ans) {
    var n = ans.n || 1, items = [], machine = null, machines = [];
    function add(p, role, opt, qty) { if (p) items.push({ p: p, role: role, on: !opt, opt: !!opt, qty: qty || n }); }
    if (kind === 'uusi') {
      var pref = ans.taso === 'tehokas' ? H.e16 : H.v15;
      machine = byHandle(pref);
      if (!machine || !inStock(machine, n)) {
        machines = DATA.filter(function (p) { return isLaptop(p) && hasTag(p, 'kaytto:toimisto') && p.m.kunto === 'Uusi' && inStock(p, n); });
        machines.sort(function (a, b) { return ans.taso === 'tehokas' ? b.p - a.p : a.p - b.p; });
        machine = machines[0] || null;
      }
      add(machine, 'Kone');
      add(pickRole(H.telakka, 'telakka', n), 'Telakka');
      add(pickRole(H.n24, 'naytto', n), 'Näyttö');
      add(pickRole(H.combo, 'nappis-hiiri', n), 'Näppäimistö ja hiiri');
      add(pickRole(H.voip, 'kuulokkeet', n), 'Kuulokkeet');
      add(bagFor(machine, null, n), 'Laukku');
    } else if (kind === 'toimisto') {
      machines = DATA.filter(function (p) { return isLaptop(p) && hasTag(p, 'kaytto:toimisto') && inStock(p); })
        .sort(function (a, b) { return (b.m.kunto === 'Kunnostettu') - (a.m.kunto === 'Kunnostettu') || a.p - b.p; });
      machine = machines[0] || null;
      add(machine, 'Kone', false, 1);
      if (ans.naytot) add(pickRole(H.n24, 'naytto', ans.naytot), 'Näyttö', false, ans.naytot);
      add(pickRole(H.kb216, 'nappis-hiiri'), 'Näppäimistö', false, 1);
      add(pickRole(H.ms300, 'nappis-hiiri'), 'Hiiri', false, 1);
      add(pickRole(H.voip, 'kuulokkeet'), 'Kuulokkeet', !ans.kuulokkeet, 1);
    } else if (kind === 'eta') {
      if (!ans.omakone) {
        machines = DATA.filter(function (p) { return isLaptop(p) && hasTag(p, 'kaytto:toimisto') && inStock(p); }).sort(function (a, b) { return a.p - b.p; });
        machine = machines[0] || null;
        add(machine, 'Kone', false, 1);
      }
      add(pickRole(H.telakka, 'telakka'), 'Telakka', false, 1);
      add(pickRole(ans.naytto === 27 ? H.n27 : H.n24, 'naytto'), 'Näyttö', false, 1);
      add(pickRole(H.combo, 'nappis-hiiri'), 'Näppäimistö ja hiiri', false, 1);
      add(pickRole(H.voip, 'kuulokkeet'), 'Kuulokkeet', false, 1);
    } else if (kind === 'opiskelija' || kind === 'liikkuva') {
      machine = ans.machine;
      add(machine, 'Kone', false, 1);
      if (kind === 'opiskelija') { add(bagFor(machine, 'reppu'), 'Reppu', false, 1); add(pickRole(H.usbhiiri, 'nappis-hiiri'), 'Hiiri', false, 1); }
      else add(bagFor(machine), 'Laukku', false, 1);
    }
    return { kind: kind, items: items, machine: machine, machines: machines.slice(0, 3) };
  }
  var PKG_TITLE = { uusi: 'Konepaketti uudelle työntekijälle', toimisto: 'Toimistopaketti', eta: 'Etätyöpiste', opiskelija: 'Opiskelijapaketti', liikkuva: 'Liikkuvan työn paketti' };

  /* ---------- Näkymät ---------- */
  function setView(html, canBack) {
    body.innerHTML = html;
    backBtn.hidden = !canBack;
    body.scrollTop = 0;
  }
  function push() { S.hist.push(JSON.stringify({ seg: S.seg, pick: S.pick && S.pick.id, ans: S.ans, qi: S.qi })); }
  function back() {
    var last = S.hist.pop();
    if (!last) return viewStart();
    var st = JSON.parse(last);
    S.seg = st.seg; S.ans = st.ans; S.qi = st.qi; S.pick = st.pick ? findPick(st.pick) : null;
    if (!S.seg) return viewStart(true);
    if (!S.pick) return viewPicks(true);
    return step(true);
  }
  function findPick(id) {
    var all = PICKS.yksityis.concat(PICKS.yritys);
    return all.filter(function (p) { return p.id === id; })[0];
  }
  function opt(label, data, quiet) {
    return '<button type="button" class="la-opt' + (quiet ? ' la-opt--quiet' : '') + '" ' + data + '>' +
      '<span class="la-opt__txt">' + esc(label) + '</span></button>';
  }

  function viewStart(noPush) {
    S = { seg: null, pick: null, ans: {}, qi: 0, hist: [] };
    setView(
      '<div class="la-msg"><p><strong>Hei! Autan löytämään sopivan koneen tai kokoamaan työpisteen.</strong></p><p>Vastaat pariin kysymykseen, ja saat 2–3 ehdotusta varastossa olevista tuotteista.</p></div>' +
      '<div class="la-opts">' +
      opt('Olen yksityisasiakas', 'data-seg="yksityis"') +
      opt('Olen yritysasiakas', 'data-seg="yritys"') +
      opt('En tarvitse apua, haluan vain selailla tuotteita', 'data-seg="selaa"', true) +
      '</div>', false);
  }

  function pickAvailable(p) {
    if (p.route || p.acc) return true;
    if (p.pkg === 'uusi' || p.pkg === 'eta') { return !!pickRole(H.n24, 'naytto') && !!pickRole(H.telakka, 'telakka'); }
    if (p.pkg === 'toimisto') return DATA.some(function (x) { return isLaptop(x) && hasTag(x, 'kaytto:toimisto') && inStock(x); });
    if (p.id === 'B4') return DATA.some(function (x) { return isLaptop(x) && hasTag(x, 'kaytto:toimisto') && inStock(x, 2); });
    return DATA.some(function (x) { return isLaptop(x) && hasTag(x, p.tag) && inStock(x); });
  }

  function viewPicks(noPush, showAll) {
    var picks = PICKS[S.seg].filter(pickAvailable);
    var max = 6, shown = showAll ? picks : picks.slice(0, max);
    var intro = S.seg === 'yritys'
      ? '<div class="la-msg"><p>Mitä yrityksellenne tarvitaan? Näytän hinnat myös ilman arvonlisäveroa.</p></div>'
      : '<div class="la-msg"><p>Mihin tarvitset konetta?</p></div>';
    var html = intro + '<div class="la-opts">' + shown.map(function (p) { return opt(p.label, 'data-pick="' + p.id + '"'); }).join('') + '</div>';
    if (!showAll && picks.length > max) html += '<button type="button" class="la-more" data-more>Lisää vaihtoehtoja (' + (picks.length - max) + ')</button>';
    setView(html, true);
  }

  function step(noPush) {
    var p = S.pick;
    if (p.route === 'Y8') return viewRoute('Y8');
    if (p.route === 'B7') return viewRoute('B7');
    if (p.acc) return viewAcc();
    var qs = p.q || [];
    if (S.qi < qs.length) {
      var q = Q[qs[S.qi]];
      setView('<p class="la-h">' + esc(q.t) + '</p><div class="la-opts">' +
        q.o.map(function (o, i) { return opt(o[0], 'data-ans="' + i + '"'); }).join('') + '</div>' +
        '<p class="la-note">Kysymys ' + (S.qi + 1) + '/' + qs.length + '</p>', true);
      return;
    }
    if (p.pkg && p.pkg !== 'opiskelija') return viewPackage(buildPackage(p.pkg, S.ans));
    return viewResults();
  }

  function viewRoute(id) {
    var opts = id === 'Y8'
      ? [['Selailuun, sähköpostiin ja videoihin', 'Y1'], ['Opiskeluun', 'Y2'], ['Kuljetan mukana paljon', 'Y3'], ['Iso ja selkeä näyttö', 'Y4']]
      : [['Toimistoon', 'B2'], ['Liikkuvaan myyntityöhön', 'B5'], ['Etätyöhön kotiin', 'B3'], ['Useita samanlaisia koneita', 'B4']];
    var avail = opts.filter(function (o) { return pickAvailable(findPick(o[1])); });
    setView('<p class="la-h">Mihin konetta käytetään eniten?</p><div class="la-opts">' +
      avail.map(function (o) { return opt(o[0], 'data-goto="' + o[1] + '"'); }).join('') + '</div>', true);
  }

  function cardHtml(p, opts) {
    opts = opts || {};
    var specs = [p.m.cpu, p.m.ram && p.m.ram + ' Gt RAM', p.m.ssd && p.m.ssd + ' Gt SSD', p.m.in && String(p.m.in).replace('.', ',') + '″', p.m.kg && String(p.m.kg).replace('.', ',') + ' kg'].filter(Boolean).join(' · ');
    var badges = '';
    if (p.m.kunto === 'Kunnostettu') badges += '<span class="la-badge la-badge--ref">Kunnostettu' + (p.m.kl ? ' · kunto: ' + esc(p.m.kl) : '') + '</span>';
    else if (p.m.kunto === 'Uusi') badges += '<span class="la-badge">Uusi</span>';
    if (p.m.takuu) badges += '<span class="la-badge">Takuu ' + (p.m.takuu % 12 === 0 ? p.m.takuu / 12 + ' v' : p.m.takuu + ' kk') + '</span>';
    if (p.inv === 1) badges += '<span class="la-badge la-badge--last">Viimeinen kappale</span>';
    if (opts.cheapest) badges += '<span class="la-badge la-badge--cheap">Edullisin vaihtoehto</span>';
    var price = '<div class="la-price">' + eur(p.p) + (S.seg === 'yritys' ? '<small>' + eur(alv0(p.p)) + ' ALV 0 %</small>' : '') + '</div>';
    var why = opts.why ? '<p class="la-why">' + esc(opts.why.charAt(0).toUpperCase() + opts.why.slice(1)) + '.</p>' : '';
    return '<article class="la-card">' +
      (p.img ? '<img class="la-card__img" src="' + esc(p.img) + '" alt="" loading="lazy" width="72" height="72">' : '<div class="la-card__img la-card__img--empty"></div>') +
      '<div><p class="la-card__title"><a href="' + esc(p.u) + '" data-open="' + p.id + '">' + esc(p.t) + '</a></p>' +
      (specs ? '<p class="la-card__specs">' + esc(specs) + '</p>' : '') +
      '<div class="la-badges">' + badges + '</div>' + price + '</div>' + why +
      '<div class="la-card__actions">' +
      '<button type="button" class="la-btn" data-add="' + p.vid + '" data-pid="' + p.id + '" data-qty="' + (opts.qty || 1) + '">Lisää koriin' + (opts.qty > 1 ? ' (' + opts.qty + ' kpl)' : '') + '</button>' +
      '<a class="la-btn la-btn--ghost" href="' + esc(p.u) + '" data-open="' + p.id + '">Katso tuote</a>' +
      (opts.pkg ? '' : '') + '</div></article>';
  }

  function viewResults() {
    var p = S.pick, r = recommend(p, S.ans);
    if (!r.list.length) return viewEmpty();
    var html = '<div class="la-msg"><p>' + (r.list.length === 1 ? 'Tämä sopii toiveisiisi parhaiten:' : 'Nämä sopivat toiveisiisi parhaiten:') + '</p></div>';
    if (r.note) html += '<p class="la-note la-note--warn">' + esc(r.note) + '</p>';
    html += r.list.map(function (x) {
      return cardHtml(x, { why: whyText(x, S.ans), cheapest: r.list.length > 1 && x === r.cheapest, qty: S.ans.n && S.pick.id === 'B4' ? S.ans.n : 1 });
    }).join('');
    if (p.pkg === 'opiskelija' && r.list[0]) {
      html += '<p class="la-h">Tai opiskelijapaketti</p>' + pkgHtml(buildPackage('opiskelija', { machine: r.list[0] }));
    }
    if (p.id === 'Y3' || p.id === 'B5') {
      if (r.list[0]) html += '<p class="la-h">Tai liikkuvan työn paketti</p>' + pkgHtml(buildPackage('liikkuva', { machine: r.list[0] }));
    }
    S.shown = r.list.map(function (x) { return { p: x, qty: 1 }; });
    html += formHtml();
    setView(html, true);
    track('suositus_naytetty', { tuotteet: r.list.map(function (x) { return x.h; }) });
  }

  function viewEmpty() {
    setView('<div class="la-msg"><p>Tähän toiveeseen sopivaa konetta ei juuri nyt ole varastossa.</p><p>Jätä yhteystietosi, niin asiantuntijamme etsii sinulle sopivan vaihtoehdon, tai soita 040 040 5878.</p></div>' + formHtml(true), true);
    track('ei_tuloksia', {});
  }

  function pkgHtml(pkg) {
    if (!pkg.items.length) return '';
    var refurb = pkg.machine && pkg.machine.m.kunto === 'Kunnostettu';
    var rows = pkg.items.map(function (it, i) {
      return '<label class="la-pkg__row"><input type="checkbox" data-pkgi="' + i + '"' + (it.on ? ' checked' : '') + '>' +
        (it.p.img ? '<img src="' + esc(it.p.img) + '" alt="" loading="lazy">' : '<span></span>') +
        '<span><small>' + esc(it.role) + (it.qty > 1 ? ' × ' + it.qty : '') + '</small><br><a href="' + esc(it.p.u) + '" target="_blank" rel="noopener">' + esc(it.p.t) + '</a>' + (it.opt ? ' <small>(valinnainen)</small>' : '') + '</span>' +
        '<span>' + eur(it.p.p) + '</span></label>';
    }).join('');
    var key = 'pkg' + Math.random().toString(36).slice(2, 8);
    PKGS[key] = pkg;
    return '<div class="la-pkg" data-pkg="' + key + '"><p class="la-h" style="margin-top:0">' + esc(PKG_TITLE[pkg.kind]) + '</p>' + rows +
      '<div class="la-pkg__total"><span>Yhteensä</span><span data-total></span></div>' +
      (refurb ? '<p class="la-note">Kun ostat tarvikkeet kunnostetun koneen kanssa, saat niistä 10 % alennuksen automaattisesti kassalla (enintään 4 tarviketta, ei koneesta).</p>' : '') +
      '<button type="button" class="la-btn" data-addpkg="' + key + '" style="width:100%">Lisää paketti koriin</button></div>';
  }
  var PKGS = {};
  function updateTotals() {
    root.querySelectorAll('.la-pkg').forEach(function (el) {
      var pkg = PKGS[el.dataset.pkg]; if (!pkg) return;
      var sum = 0;
      el.querySelectorAll('[data-pkgi]').forEach(function (cb) { var it = pkg.items[+cb.dataset.pkgi]; it.on = cb.checked; if (cb.checked) sum += it.p.p * it.qty; });
      el.querySelector('[data-total]').innerHTML = eur(sum) + (S.seg === 'yritys' ? '<small>' + eur(alv0(sum)) + ' ALV 0 %</small>' : '');
    });
  }

  function viewPackage(pkg) {
    if (!pkg.items.length) return viewEmpty();
    var n = S.ans.n || 1;
    var html = '<div class="la-msg"><p>Kokosin valmiin paketin varastossa olevista tuotteista. Voit poistaa osan ennen kuin lisäät paketin koriin.</p>' +
      (n > 1 ? '<p>Määrät on laskettu ' + n + ' työntekijälle.</p>' : '') + '</div>';
    if (n >= 5) html += '<p class="la-note">Viidelle tai useammalle teemme mielellämme määrätarjouksen – jätä yhteystietosi alla.</p>';
    S.shown = pkg.items.map(function (i) { return { p: i.p, qty: i.qty }; });
    html += pkgHtml(pkg) + formHtml(n >= 5);
    setView(html, true);
    updateTotals();
    track('paketti_naytetty', { paketti: pkg.kind, tuotteet: pkg.items.map(function (i) { return i.p.h; }) });
  }

  function viewAcc() {
    if (S.ans.acc == null) {
      setView('<p class="la-h">Mitä etsit?</p><div class="la-opts">' + ACC.map(function (a) { return opt(a[0], 'data-acc="' + a[1] + '"'); }).join('') + '</div>', true);
      return;
    }
    var role = S.ans.acc, list;
    if (role === 'laturi') list = DATA.filter(function (p) { return /laturi/i.test(p.t) && inStock(p); });
    else if (role === 'telakka') list = DATA.filter(function (p) { return (hasTag(p, 'paketti:telakka') || /telakka/i.test(p.t)) && inStock(p); });
    else list = DATA.filter(function (p) { return hasTag(p, 'paketti:' + role) && inStock(p); });
    list.sort(function (a, b) { return a.p - b.p; });
    var html = '';
    if (role === 'laturi') html += '<p class="la-note">Laturin pitää sopia koneeseesi. Lenovon 68 W USB-C-laturi sopii USB-C-latautuviin Lenovoihin. Dellin koneisiin suosittelemme koneen omaa laturia – kysy tarvittaessa 040 040 5878.</p>';
    if (!list.length) return viewEmpty();
    S.shown = list.slice(0, 4).map(function (x) { return { p: x, qty: 1 }; });
    html += list.slice(0, 4).map(function (p) { return cardHtml(p); }).join('');
    setView(html, true);
    track('suositus_naytetty', { tuotteet: list.slice(0, 4).map(function (x) { return x.h; }), lisavaruste: role });
  }

  function formHtml(force) {
    var biz = S.seg === 'yritys';
    var open = biz || force;
    var inner = '<form class="la-form" data-form>' +
      '<p class="la-h">' + (biz ? 'Haluatko tarjouksen tai apua valintaan?' : 'Saako sinuun ottaa yhteyttä ja auttaa valinnassa?') + '</p>' +
      '<label for="la-n">Nimi</label><input id="la-n" type="text" name="nimi" autocomplete="name" required>' +
      (biz ? '<label for="la-y">Yritys</label><input id="la-y" type="text" name="yritys" autocomplete="organization">' : '') +
      '<label for="la-e">Sähköposti</label><input id="la-e" type="email" name="email" autocomplete="email" required>' +
      '<label for="la-p">Puhelin (valinnainen)</label><input id="la-p" type="tel" name="puhelin" autocomplete="tel">' +
      '<label for="la-v">Viesti (valinnainen)</label><textarea id="la-v" name="viesti"></textarea>' +
      '<label class="la-consent"><input type="checkbox" name="lupa" required> <span>Louru saa ottaa minuun yhteyttä näistä valinnoista. Tietoja käytetään vain tähän yhteydenottoon.</span></label>' +
      '<button type="submit" class="la-btn" style="width:100%">Lähetä</button></form>';
    if (open) return inner;
    return '<details class="la-form"><summary class="la-more" style="list-style:none;cursor:pointer">Haluatko, että asiantuntija auttaa? Jätä yhteystietosi</summary>' + inner.replace('class="la-form"', 'class="la-form" style="border:0;margin:0"') + '</details>';
  }

  /* ---------- Ostoskori ---------- */
  function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.dataset.txt = btn.textContent; btn.textContent = 'Lisätään…'; }
    var payload = { items: items.map(function (i) { return { id: i.id, quantity: i.qty, properties: { _lahde: 'ostosavustaja', _avustaja: (S.pick && S.pick.id) || '' } }; }) };
    return fetch(root.dataset.cartAdd, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root.dataset.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'louru-avustaja', data: { itemCount: cart.item_count, source: 'louru-avustaja' } } })); } catch (e) {}
        try { var ad = JSON.parse(store.get('added') || '[]'); items.forEach(function (i) { if (i.h && ad.indexOf(i.h) === -1) ad.push(i.h); }); store.set('added', JSON.stringify(ad)); } catch (e) {}
        track('lisatty_koriin', { tuotteet: items.map(function (i) { return i.h; }), kpl: items.reduce(function (s, i) { return s + i.qty; }, 0) });
        var done = document.createElement('div');
        done.className = 'la-done';
        done.innerHTML = 'Lisätty koriin. <a href="' + root.dataset.cart + '" style="color:inherit">Siirry ostoskoriin (' + cart.item_count + ')</a>';
        var host = btn ? btn.closest('.la-card, .la-pkg') : null;
        if (host) host.insertAdjacentElement('afterend', done); else body.prepend(done);
        if (btn) { btn.textContent = 'Korissa'; }
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.txt; }
        var msg = (err && (err.description || err.message)) || 'Lisäys ei onnistunut.';
        var e = document.createElement('p'); e.className = 'la-note la-note--warn'; e.textContent = msg + ' Kokeile uudelleen tai soita 040 040 5878.';
        (btn ? btn.closest('.la-card, .la-pkg') : body).appendChild(e);
        track('virhe_koriin', { viesti: msg });
      });
  }

  /* ---------- Avaus, sulkeminen, Gorgias ---------- */
  function open() {
    store.set('teaser', 'x'); teaser.hidden = true;
    root.classList.add('is-open'); root.classList.remove('is-min');
    document.documentElement.classList.add('la-open');
    try { if (window.GorgiasChat && GorgiasChat.isOpen && GorgiasChat.isOpen()) GorgiasChat.close(); } catch (e) {}
    panel.hidden = false; fab.setAttribute('aria-expanded', 'true');
    track('avattu', { sivu: root.dataset.template });
    /* Korjaus 7.10.: jos ikkuna on tyhjä (ensimmäinen avaus), näytä aina latausnäkymä – myös silloin,
       kun tuotteet on jo esiladattu hiiren käydessä painikkeen päällä. Muuten ensimmäinen näkymä jäi piirtämättä. */
    if (!body.firstElementChild) setView('<div class="la-spin" role="status" aria-label="Ladataan"></div>', false);
    load().then(function () {
      if (!body.querySelector('.la-spin')) return;
      var seg = store.get('seg');
      if (seg && seg !== 'selaa') { S.seg = seg; viewPicks(); } else viewStart();
    }).catch(function () {
      setView('<div class="la-msg"><p>Tuotteiden lataus ei nyt onnistunut. Soita 040 040 5878 tai kirjoita tuki@louru.fi, niin autamme.</p></div>', false);
    });
    setTimeout(function () { var f = panel.querySelector('.la-close'); if (f) f.focus(); }, 50);
  }
  function close(min) {
    root.classList.remove('is-open');
    root.classList.add('is-min');
    document.documentElement.classList.remove('la-open');
    panel.hidden = true; fab.setAttribute('aria-expanded', 'false');
    fab.focus();
  }
  function hookGorgias() {
    var tries = 0;
    (function wait() {
      if (window.GorgiasChat && GorgiasChat.init) {
        GorgiasChat.init().then(function () {
          if (!GorgiasChat.on) return;
          GorgiasChat.on('widget:opened', function () { if (root.classList.contains('is-open')) close(); document.documentElement.classList.add('la-gorgias-open'); });
          GorgiasChat.on('widget:closed', function () { document.documentElement.classList.remove('la-gorgias-open'); });
        }).catch(function () {});
      } else if (tries++ < 60) setTimeout(wait, 1000);
    })();
  }

  /* ---------- Tapahtumat ---------- */
  fab.addEventListener('click', open);
  fab.addEventListener('pointerenter', function () { load().catch(function () {}); }, { once: true });
  root.querySelector('.la-close').addEventListener('click', function () { close(); track('suljettu', {}); });
  backBtn.addEventListener('click', back);
  teaser.querySelector('.la-teaser__close').addEventListener('click', function () { teaser.hidden = true; store.set('teaser', 'x'); });
  teaser.addEventListener('click', function (e) { if (!e.target.closest('.la-teaser__close')) open(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  root.querySelector('.la-foot').addEventListener('click', function (e) {
    var b = e.target.closest('[data-faq]'); if (!b) return;
    push();
    setView('<div class="la-msg">' + FAQ[b.dataset.faq]() + '</div>' + opt('Takaisin valintoihin', 'data-home', true), true);
    track('ukk', { aihe: b.dataset.faq });
  });

  body.addEventListener('change', function (e) { if (e.target.matches('[data-pkgi]')) updateTotals(); });

  body.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t) return;
    if (t.hasAttribute('data-home')) { e.preventDefault(); return S.seg ? (S.pick = null, S.ans = {}, S.qi = 0, viewPicks()) : viewStart(); }
    if (t.dataset.seg) {
      if (t.dataset.seg === 'selaa') { store.set('seg', 'selaa'); store.set('teaser', 'x'); track('selaa', {}); close(true); return; }
      push(); S.seg = t.dataset.seg; store.set('seg', S.seg); track('asiakastyyppi', { asiakastyyppi: S.seg });
      return viewPicks();
    }
    if (t.hasAttribute('data-more')) return viewPicks(true, true);
    if (t.dataset.pick || t.dataset.goto) {
      push(); S.pick = findPick(t.dataset.pick || t.dataset.goto); S.ans = {}; S.qi = 0;
      track('pikavalinta', { valinta: S.pick.id });
      return step();
    }
    if (t.dataset.ans != null) {
      push(); var qk = S.pick.q[S.qi], q = Q[qk], o = q.o[+t.dataset.ans]; Object.assign(S.ans, o[1]); S.ans['_' + qk] = q.t + ' ' + o[0]; S.qi++;
      return step();
    }
    if (t.dataset.acc) { push(); S.ans.acc = t.dataset.acc; S.ans._acc = 'Mitä etsit? ' + t.textContent.trim(); return viewAcc(); }
    if (t.dataset.add) {
      var p = DATA.filter(function (x) { return String(x.id) === t.dataset.pid; })[0];
      return addToCart([{ id: +t.dataset.add, qty: +t.dataset.qty || 1, h: p && p.h }], t);
    }
    if (t.dataset.addpkg) {
      var pkg = PKGS[t.dataset.addpkg];
      var items = pkg.items.filter(function (i) { return i.on; }).map(function (i) { return { id: i.p.vid, qty: i.qty, h: i.p.h }; });
      if (!items.length) return;
      track('paketti_koriin', { paketti: pkg.kind });
      return addToCart(items, t);
    }
    if (t.dataset.open) track('tuote_avattu', { tuote: t.dataset.open });
  });

  /* Yhteydenottolomake -> Klaviyo-tapahtuma "Ostosavustaja: yhteydenotto".
     Klaviyon flow odottaa 12 h ja lähettää ilmoituksen osoitteeseen tuki@louru.fi, jos asiakas ei ole tilannut.
     Tapahtuma ei liitä asiakasta markkinointilistoille. */
  var KLAVIYO_KEY = 'UkfM8V';
  function buildLead(d) {
    var added = [];
    try { added = JSON.parse(store.get('added') || '[]'); } catch (e) {}
    var origin = location.origin;
    var shown = (S.shown || []).map(function (x) {
      return { nimi: x.p.t, hinta: eur(x.p.p), kpl: x.qty || 1, url: origin + x.p.u, korissa: added.indexOf(x.p.h) !== -1 };
    });
    var vast = Object.keys(S.ans).filter(function (k) { return k.charAt(0) === '_'; }).map(function (k) { return S.ans[k]; });
    var rivit = shown.map(function (x, i) {
      return (i + 1) + '. ' + x.nimi + ' – ' + x.hinta + (x.kpl > 1 ? ' – kpl ' + x.kpl : '') + ' – ' + (x.korissa ? 'korissa' : 'ei korissa') + '\n   ' + x.url;
    });
    return {
      asiakastyyppi: S.seg === 'yritys' ? 'Yritysasiakas' : 'Yksityisasiakas',
      valinta: (S.pick && S.pick.label) || '(ei pikavalintaa)',
      valinta_tunnus: (S.pick && S.pick.id) || '',
      vastaukset: vast.join(' · ') || '–',
      nimi: d.nimi || '', yritys: d.yritys || '', puhelin: d.puhelin || '', viesti: d.viesti || '',
      tuotteet: shown,
      tuotelista: rivit.join('\n') || '(ei tuotteita)',
      sivu: location.href,
      lahde: 'ostosavustaja'
    };
  }
  function sendLead(d, lead) {
    var body = { data: { type: 'event', attributes: {
      properties: lead,
      metric: { data: { type: 'metric', attributes: { name: 'Ostosavustaja: yhteydenotto' } } },
      profile: { data: { type: 'profile', attributes: { email: d.email, first_name: (d.nimi || '').split(' ')[0] || undefined, last_name: (d.nimi || '').split(' ').slice(1).join(' ') || undefined, organization: d.yritys || undefined } } }
    } } };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_KEY, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
  }

  body.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-form]'); if (!f) return;
    e.preventDefault();
    var d = {}; new FormData(f).forEach(function (v, k) { d[k] = String(v).trim(); });
    var btn = f.querySelector('[type=submit]'); if (btn) { btn.disabled = true; btn.textContent = 'Lähetetään…'; }
    var lead = buildLead(d);
    sendLead(d, lead).then(function () {
      track('yhteydenotto', { yritys: !!d.yritys });
      f.outerHTML = '<div class="la-done">Kiitos, ' + esc((d.nimi || '').split(' ')[0]) + '! Asiantuntijamme palaa asiaan pian.</div>';
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Lähetä'; }
      var n = document.createElement('p'); n.className = 'la-note la-note--warn';
      n.textContent = 'Lähetys ei onnistunut. Soita 040 040 5878 tai kirjoita tuki@louru.fi.';
      f.appendChild(n);
      track('virhe_lomake', {});
    });
  });

  /* ---------- Käynnistys ---------- */
  /* Painike näytetään vasta, kun tyylitiedosto on latautunut (se ladataan viiveellä sivun nopeuden takia) */
  function reveal() { root.hidden = false; }
  if (getComputedStyle(root).getPropertyValue('--la-accent').trim()) reveal();
  else {
    var css = document.getElementById('la-css');
    if (css) css.addEventListener('load', function () { requestAnimationFrame(reveal); });
    setTimeout(reveal, 5000);
  }
  if (store.get('seg') === 'selaa' || store.get('min')) root.classList.add('is-min');
  /* 8 s jälkeen leveä painike kutistuu kysymysmerkkipalloksi (myös työpöydällä) ja pysyy pienenä saman käynnin ajan */
  setTimeout(function () { if (!root.classList.contains('is-open')) { root.classList.add('is-min'); store.set('min', '1'); } }, 8000);
  hookGorgias();
  var tpl = root.dataset.template;
  if (!store.get('teaser') && (tpl === 'index' || tpl === 'collection' || tpl === 'product')) {
    setTimeout(function () { if (!root.classList.contains('is-open') && !store.get('teaser')) teaser.hidden = false; }, 12000);
  }
})();
